import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
import { TransformCta } from './CtaButton';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-29" data-mp="3ogatplxd8t37">
      <div className="mx-auto max-w-5xl" data-id="element-30" data-mp="3oi40r2bw5fbq">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-31" data-mp="3sgl8no34ytu7">
          De sentir incertidumbre frente a un caso complejo a tener un plan claro desde la primera
          consulta
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[14px] leading-relaxed text-navy-800/70 sm:text-lg" data-id="element-32" data-mp="3jirikuvyswfh">
          Deja de perder tiempo buscando respuestas entre artículos, guías y protocolos dispersos. La
          Ruta organiza todo el proceso clínico en una secuencia lógica para que cada decisión tenga
          un fundamento claro.
        </p>

        <div className="mt-9 grid gap-5 md:grid-cols-2" data-id="element-33" data-mp="30p5ffb72q8v0">
          {/* ANTES */}
          <div className="rounded-3xl border border-red-200 bg-red-50/70 p-5 sm:p-6" data-id="element-34" data-mp="x3siojg0lius">
            <h3 className="mb-4 flex items-center gap-2 font-display text-lg font-bold text-red-800 sm:text-xl" data-id="element-35" data-mp="t38j797yy35h">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-red-500 text-white" data-id="element-36" data-mp="172zuv3b0j7gb">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="124omyy4a370q" />
              </span>
              Antes
            </h3>
            <ul className="space-y-3" data-id="element-38" data-mp="eelu4fsjhx12">
              {beforeItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-39" data-mp="9galu9hw7uky">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-40" data-mp="o3lwm9693ak0" />
                  <span className="text-[13.5px] leading-relaxed text-navy-900/80 sm:text-[15px]" data-id="element-41" data-mp="jbkq73vrke1w">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* DESPUÉS */}
          <div className="rounded-3xl border border-emerald-200 bg-emerald-50/70 p-5 sm:p-6" data-id="element-42" data-mp="1qqzh9z1j5p9h">
            <h3 className="mb-4 flex items-center gap-2 font-display text-lg font-bold text-emerald-800 sm:text-xl" data-id="element-43" data-mp="1vpu9frle0q69">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-500 text-white" data-id="element-44" data-mp="20g0xnqbzm8nz">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="24h2xa89tgmqh" />
              </span>
              Con la Ruta Fertilidad Masculina
            </h3>
            <ul className="space-y-3" data-id="element-46" data-mp="17u813yhabq9n">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-47" data-mp="1cr87yblykx1t">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-48" data-mp="1gsa7ktjsfb4b" />
                  <span className="text-[13.5px] font-medium leading-relaxed text-navy-900/85 sm:text-[15px]" data-id="element-49" data-mp="1lpa70lm4tfmg">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <TransformCta headline="Cambia la incertidumbre por un plan claro desde hoy." data-id="element-50" data-mp="379owbjypbks0" />
      </div>
    </section>;
}